import { useEffect, useState } from "react";

const DynamicGenerator = ({ text, stopGenerating }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [length, setLength] = useState(0);
  useEffect(() => {
    if (stopGenerating) {
      setDisplayedText(text);
    }
    const interval = setInterval(() => {
      // Check if there are more characters to display
      if (displayedText.length < text.length) {
        // Add the next character to the displayed text
        setDisplayedText((prevText) => prevText + text[length]);
        setLength(length + 1);
      } else {
        clearInterval(interval); // Stop interval once the entire paragraph is displayed
      }
    }, 20); // Adjust the speed of text generation (in milliseconds)

    return () => clearInterval(interval); // Clean up on component unmount
  }, [displayedText, text]);
  return displayedText;
};
export default DynamicGenerator;
